import config from '~/authentication/lib/config';
import { isAbortedRequest } from '~/authentication/lib/classifyAuthError';
import { REQUEST_HEADERS } from '~/services/headers';
// --- internal imports ------

async function setupUserAccount(userToken, user) {
	try {
		if (!user.firstName) {
			console.error('\'firstName\' not provided in \'user\' object.');
			return false;
		}

		if (!user.lastName) {
			console.error('\'lastName\' not provided in \'user\' object.');
			return false;
		}

		if (!user.department) {
			console.error('\'department\' not provided in \'user\' object.');
			return false;
		}

		if (user.otherEmail === '') {
			delete user.otherEmail;
		}
		
		const baseUrl = config.userbaseServerBaseUrl;
		const response = await fetch(`${baseUrl}/api/user/`, {
			method: 'PATCH', 
			headers: {
				...REQUEST_HEADERS,
				'authorization': `Bearer ${userToken}`
			},
			body: JSON.stringify(user),
			signal: AbortSignal.timeout(15000)
		});

		// The status is the contract here, not the body. This PATCH is the commit
		// point of registration — the server activates the licence and answers 200
		// only once the transaction has gone through — and nothing between here and
		// the login form reads the row, because the session ends on the way. Reading
		// a user out of the body made a committed registration look refused, and it
		// also let a real refusal (`400 Player license is not valid`) through the
		// same path, since an error body parses just as cleanly as a success one.
		if (!response.ok) {
			console.error(`Registration was refused (HTTP ${response.status}).`);
			return false;
		}

		return true;
	}
	catch(e) {
		console.error(e);

		// A request that was cut off is not a refusal, and must not collapse into
		// the same `null`. This PATCH is what completes registration — it flips the
		// licence from pending to active in the same transaction — so a resubmit
		// after one that did land fails permanently. The screen has to be able to
		// say the outcome is unknown rather than invite another attempt.
		if (isAbortedRequest(e)) {
			throw e;
		}

		return false;
	}
}

export default setupUserAccount;
